/* 🧩 COMPONENTS */
import { Button } from "../../Components";

/* 🧠 REDUX */
import { ChangeUserInfo, ChangeCheckedTutorial } from "../../Redux/Actions";
import { store } from "../../Redux/Store";

/* 🔧 UTILS */
import { createStep } from "./index";

export const homeSteps = (t) => [
  createStep({
    selector: '#tour-button',
    stepNumber: 1,
    titleKey: t("tour.home.tour-button.title"),
    textKey: t("tour.home.tour-button.text"),
    customClose: () => store.dispatch(ChangeCheckedTutorial(true)),
    children: (setIsOpen) => (
      <> 
        <Button color={"green"} text={t("buttons.enable")} padding={"6px 20px"} onClick={() => {
          setIsOpen(false);
          store.dispatch(ChangeCheckedTutorial(true));
        }}/>
        <Button id={"no-thanks"} text={t("buttons.no-thanks")} padding={"6px 20px"} onClick={() => {
          let newuser = store.getState().userReducer;
          newuser = {
            ...newuser,
            user : {
              ...newuser.user,
              checkedTutorial: true,
            }
          }
          store.dispatch(ChangeUserInfo(newuser));
          store.dispatch(ChangeCheckedTutorial(true));
          setIsOpen(false);
        }}/>
      </>
    )
  })
]